module.exports = __webpack_public_path__ + "static/media/musgrave.b052aeef.png";